module.exports = __webpack_public_path__ + "static/img/setup_terminal_commands.db55005.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/python/images/setup_terminal_commands.png
// module id = M/1A
// module chunks = 1